import type { PermissionRoles } from '../../../../auth/common/interfaces/permission-roles';

export enum AdminPanelPermission {
  ADMIN_PANEL = 'adminPanel',
}

export const getAdminPanelPermissions = (
  roles: PermissionRoles,
): Record<AdminPanelPermission, boolean> => ({
  [AdminPanelPermission.ADMIN_PANEL]: roles.isSystemAdmin,
});
